<template>
  <div class="cc_page">

   <!-- tools -->
   <div class="m_tools">
     <div class="m_tools_list" v-for="item in scoreLists">
      <div class="scoreInfo">
       <img :src="globalUrl+'images/01.png'" class="icon_tools" v-if="item.score>0" />
       <img :src="globalUrl+'images/07.png'" class="icon_tools" v-else/>
       <span class="tools_title">{{item.eventName=='推广员推荐新用户'?'推荐新用户':item.eventName}}</span>
      </div>
      <span :class="item.score>0?'red':'green'">{{item.score>0?'+':''}}{{item.score}}{{item.status!='订单结算'?'(暂冻结)':''}}券币</span>
     <span class="time">{{item.time}}</span>

     </div>
   </div>
  </div>
</template>
<script type = "span/ecamscript-6">
 import { Indicator } from 'mint-ui' //加载更多
 import {getDateDiff,config} from "../../common/js/common.js"
  export default {
    name:"coinsCenterList",
    props:['openID'],
    data(){
      return{
        page:1,
        pageSize:30,
        scoreLists:[],
        globalUrl:config.gobalUrl
      }
    },
    created(){
      this.login()
    },
    methods:{
      login () {

        this.url = "api/getScoreList.php?openID="+this.openID+"&page="+this.page+"&pageSize="+this.pageSize
        this.$ajax.autoService
            .login(this.url)
            .then((res) => {
            this.scoreLists=this.scoreLists.concat(res.data.map(function (item) {
           item.time = getDateDiff(new Date(item.time.replace(/-/g, '/')));
           //item.finalPrice = (item.price - item.money).toFixed(2)

           return item
         }))
         this.$nextTick(() => {
           this.REQUIRE = true;
           this.loading = false;
           Indicator.close()
         });
       }, (res) => {
         console.log("error")
         this.REQUIRE = true;
            })
       },
       /*axios向下加载*/
       scrollBottom() {
        // 滚动到页面底部时，请求前一天的文章内容

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop


        if (((window.screen.height + scrollTop) > (document.body.clientHeight)-10)&& this.REQUIRE) {
         Indicator.open('正在加载更多');
          // 请求的数据未加载完成时，滚动到底部不再请求前一天的数据
          this.REQUIRE = false;
          this.loading = true;
          this.page+=1
          this.login()

    }
  }
},
mounted(){
   window.onscroll = this.scrollBottom
},
beforeDestroy(){
  Indicator.close()
  window.onscroll = ""
}
  }
</script>
<style lang="stylus">
  .m_tools
    margin-top: 20px
    width: 100%
    background: #fff
    .m_tools_list
      display: flex
      flex-direction: row
      justify-content: space-between
      padding: 10px 30px
      font-size: 32px;
      line-height: 60px;
      border-top: 2px solid #f2f2f2
      /*px*/
      align-items:center
      .icon_tools
        width:40px
        height:40px
        vertical-align:middle
      .red
        color:red
      .green
        color:green
      .time
        color: gray
        font-size: 27px
</style>



// WEBPACK FOOTER //
// src/components/userCenter/coinsCenterList.vue